import type { SubscriptionOffers } from "./subscription-offers";
import { effectivePaidAccess } from "./paid-access";

export type PlanTier = "free" | "pro" | "agent";
export const AGENT_LIMITS = {
  activeAlerts: 5,
  dailyAlertSms: 5,
  monthlyAlertSegments: 620,
  includedReplies: 120,
  overageReplyCents: 10,
  defaultOverageCapCents: 200,
  maximumOverageCapCents: 10_000,
} as const;
export const AGENT_OVERAGE_TERMS = "agent-sms-overages-2026-10-09";

export function membershipTier(user: {
  isPro?: boolean; paidPro?: boolean; paidAgent?: boolean;
  complimentaryAgent?: boolean; complimentaryPro?: boolean; isTestAccount?: boolean;
  paidAccessUntil?: Date | string | null;
  billingProvider?: string | null;
  paddleProUntil?: Date | string | null;
  paddleAgentUntil?: Date | string | null;
} | null | undefined, now = new Date()): PlanTier {
  if (user) user = effectivePaidAccess(user, now);
  if (user?.complimentaryAgent || user?.isTestAccount || (user?.paidPro && user?.paidAgent)) return "agent";
  return user?.isPro ? "pro" : "free";
}

export type AgentCatalog = {
  available: boolean;
  offers?: SubscriptionOffers;
  limits: typeof AGENT_LIMITS;
  annualSavingsMonths: 2;
};

export type AgentStatus = {
  tier: PlanTier;
  isAgent: boolean;
  paidAgent: boolean;
  usage: {
    included: number; used: number; remaining: number;
    periodStart: string | null; periodEnd: string | null;
    overageReplies: number; overageCents: number; pendingReplies: number;
  };
  overages: {
    enabled: boolean; capCents: number; rateCents: number;
    paymentMethodSaved: boolean; chargingEnabled: boolean;
    canEnable: boolean; termsVersion: string;
    blockedReason: string | null;
  };
  invoices: Array<{
    id: number; amountCents: number; replies: number; status: string;
    periodStart: string; periodEnd: string;
  }>;
};
